module.exports = __webpack_public_path__ + "static/media/sala.d7e92ed8.svg";